import styled, { css } from 'styled-components';
import { colors, colorAliases } from '../../variables/colors.js';
import { fonts } from '../../variables/fonts.js';
import { transitions } from '../../variables/transitions.js';

var ListBox = styled.div.withConfig({
  displayName: "style__ListBox",
  componentId: "sc-1i675tt-0"
})(["box-sizing:border-box;cursor:pointer;display:inline-block;font-family:", ";height:56px;line-height:1;min-width:100px;position:relative;", " ", ""], fonts["default"], function (props) {
  return props.disabled && css(["cursor:default;color:", ";border:0px solid ", ";"], colors.mediumGray, colors.mediumGray);
}, function (props) {
  return props.hasNoLabel && css(["height:40px;"]);
});
var FakeSelect = styled.div.withConfig({
  displayName: "style__FakeSelect",
  componentId: "sc-1i675tt-1"
})(["border:1px solid ", ";height:100%;padding:12px 12px 8px;transition:border-color ", ";", " ", " ", " .sg-list-box-select:focus + &{border-color:", ";", "}.sg-list-box:hover &{", "}"], colors.mediumGray, transitions["default"], function (props) {
  return props.roundCorners && css(["border-radius:5px;"]);
}, function (props) {
  return props.disabled && css(["border-color:", ";"], colors.mediumGrayL1);
}, function (props) {
  return props.invalid && css(["border-color:", ";"], colorAliases.validationError);
}, colors.darkGray, function (props) {
  return props.invalid && css(["border-color:", ";"], colorAliases.validationError);
}, function (props) {
  return !props.invalid && !props.disabled && css(["border-color:", ";"], colors.darkGrayL1);
});
var Label = styled.div.withConfig({
  displayName: "style__Label",
  componentId: "sc-1i675tt-2"
})(["color:", ";display:inline-block;font-size:12px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap;width:100%;", ""], colors.darkGrayL1, function (props) {
  return props.disabled && css(["color:", ";"], colors.mediumGrayL1);
});
var SelectedItem = styled.div.withConfig({
  displayName: "style__SelectedItem",
  componentId: "sc-1i675tt-3"
})(["justify-content:space-between;overflow:hidden;padding:4px 20px 2px 0;text-overflow:ellipsis;white-space:nowrap;width:100%;", " .sg-list-box-icon{display:inline-block;font-size:13px;margin-top:3px;margin-right:10px;pointer-events:none;position:absolute;right:4px;height:14px;width:14px;z-index:1;", "}"], function (props) {
  return !props.label && css(["padding-top:0;"]);
}, function (props) {
  return props.disabled && css(["fill:", ";"], colors.mediumGrayL1);
});
var Select = styled.select.withConfig({
  displayName: "style__Select",
  componentId: "sc-1i675tt-4"
})(["bottom:0;box-sizing:border-box;font-family:", ";font-size:16px;height:100%;left:0;opacity:0;padding-left:8px;position:absolute;right:0;top:0;width:100%;", ""], fonts["default"], function (props) {
  return props.disabled && css(["cursor:default;display:none;"]);
});

export { FakeSelect, Label, ListBox, Select, SelectedItem };
//# sourceMappingURL=style.js.map
